import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { MaskedField } from 'js/containers/UserForm/MaskedField.js';
import { Grid, Typography, Button, CircularProgress, Select } from '@mui/material';
import phoneMaskArray from './phoneMaskArray.json';

import { phoneInputAction } from 'js/core/actions/phoneInputActions';

function PhoneInput(props) {
  const [cellPhone, setCellPhone] = useState('');
  const [country, setCountry] = useState('+55,(99) 99999-9999');
  const [countryNumber, setCountryNumber] = useState('+55');
  const [mask, setMask] = useState('(99) 99999-9999');

  const [loading, setLoading] = useState('');
  const [errorLabel, setErrorLabel] = useState('');

  const maskVerify = mask.replace(/\D/g, '').length === cellPhone.replace(/\D/g, '').length;

  const { t } = useTranslation();

  useEffect(() => {
    window.pathname = null;
  }, []);

  //altera os states conforme escrevemos no formulário
  const handleChange = (name) => (event) => {
    if (name === 'cellPhone') {
      setCellPhone(event.target.value);
    } else if (name === 'country') {
      setCellPhone('');
      let countrySlice = event.target.value;
      countrySlice = countrySlice.split(',');
      setCountry(event.target.value);
      setCountryNumber(countrySlice[0]);
      setMask(countrySlice[1]);

      document.getElementById('cellPhone').focus();
    }
  };

  const redirectAnonymous = () => {
    window.parent.location = window.location.origin + '';
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    props.phoneInputComponent(countryNumber + cellPhone.replace(/\D/g, ''));

    setLoading(true);
    setErrorLabel('');
  };

  if (props.error && loading) {
    try {
      if (props.error.response.data.error.errorCode === 1005) {
        setErrorLabel(t('errors.too_many_requests'));
        setLoading(false);
      } else {
        setErrorLabel(t('errors.try_later'));
        setLoading(false);
      }
    } catch {
      setErrorLabel(t('errors.try_later'));
      setLoading(false);
    }
  }

  if (window.pathname && props.success) {
    return <Navigate to={window.pathname} />;
  }

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      align="center"
      className="background-login"
    >
      <Grid size={{ md: 2, sm: 2, xs: 1 }}></Grid>

      <Grid size={{ md: 8, sm: 8, xs: 10 }}>
        <Typography variant="body2" style={{ fontSize: '1rem', paddingBottom: '10px' }}>
          {t('general.tell_your_phone_number')}
        </Typography>

        <form onSubmit={(event) => handleSubmit(event)}>
          <Select native value={country} onChange={handleChange('country')}>
            <option value={''} disabled>
              País
            </option>
            {phoneMaskArray
              .sort((a, b) => {
                const nameA = a.initials.toUpperCase(); // ignore upper and lowercase
                const nameB = b.initials.toUpperCase(); // ignore upper and lowercase
                if (nameB === 'BR') {
                  return 9999999999;
                }
                if (nameA < nameB) {
                  return -1;
                }
                if (nameA > nameB) {
                  return 1;
                }
                return 0;
              })
              .map((country) => (
                <option key={country.id} value={[country.ddd, country.mask]}>
                  {country.initials} {country.ddd}
                </option>
              ))}
          </Select>
          <MaskedField
            style={{ width: '69%', paddingLeft: '5px', marginTop: '0px' }}
            margin="normal"
            label="Celular"
            mask={mask}
            value={cellPhone}
            id="cellPhone"
            onChange={(e) => setCellPhone(e.target.value)}
          />

          <br />
          <br />
          <Typography variant="subtitle1" color="error">
            {errorLabel}
          </Typography>
          <Button
            disabled={!maskVerify || country === '' || (props.loading && loading)}
            fullWidth
            type="submit"
            variant="contained"
            color="primary"
          >
            <span
              style={{
                fontWeight: '550',
                color: 'white',
                whiteSpace: 'normal',
                textTransform: 'initial',
              }}
            >
              {' '}
              {props.loading && loading ? (
                <CircularProgress size="2rem" style={{ color: 'white' }} />
              ) : (
                <Typography variant="h6">{t('general.login')}</Typography>
              )}
            </span>
          </Button>
          {window.parent.location.pathname === '/login' ||
          window.parent.location.pathname === '/login/' ? null : (
            <Button
              disabled={props.loading && loading}
              onClick={redirectAnonymous}
              style={{ marginTop: '10px' }}
              fullWidth
              type="buttom"
              variant="contained"
              color="primary"
            >
              <span
                style={{
                  fontWeight: '550',
                  color: 'white',
                  whiteSpace: 'normal',
                  textTransform: 'initial',
                }}
              >
                {t('general.anonymous_login')}
              </span>
            </Button>
          )}
        </form>

        <Grid size={{ md: 2, sm: 2, xs: 1 }}></Grid>
      </Grid>
    </Grid>
  );
}

//recebe as props dos Reducers
function mapStateToProps(state) {
  return {
    loading: state.phoneInputComponent.loading,
    success: state.phoneInputComponent.success,
    error: state.phoneInputComponent.error,
  };
}

//envia as props para as Actions
const mapDispatchToProps = (dispatch) => ({
  phoneInputComponent: (cellPhone) => phoneInputAction(dispatch, cellPhone),
});

export default connect(mapStateToProps, mapDispatchToProps)(PhoneInput);

